module.exports = __webpack_public_path__ + "static/media/lock.a25a87a4.jpeg";